// Web Banners
import CainoBanner3 from '../assets/images/banners/casino/banner3.webp';
import IndCasinoBanner1 from '../assets/images/banners/casino/icasino_web.png';

// Mobile banners
import MobCaisnoBanner1 from '../assets/images/banners/casino/mobile_banner1.png';
import MobCaisnoBanner2 from '../assets/images/banners/casino/mobile_banner2.png';

import AviatorBanner from "../assets/images/home/aviator_banner.png";
import AviatorBannerMob from "../assets/images/home/aviator_banner_mob.png";

const CASINO_WEB_BANNERS = [
  {
    publicUrl: CainoBanner3,
    title: 'Casino',
  },
];

const FUN_GAMES_WEB_BANNER = [
  {
    image: AviatorBanner,
    text: 'Aviator',
  }
]

const FUN_GAMES_MOB_BANNER = [
  {
    image: AviatorBannerMob,
    text: 'Aviator',
  }
]

const IND_CASINO_WEB_BANNERS = [
  {
    publicUrl: IndCasinoBanner1,
    title: 'Indian Casino',
  },
];

const CASINO_MOBILE_BANNERS = [
  {
    publicUrl: MobCaisnoBanner1,
    title: 'Live Casino',
  },
  {
    image: MobCaisnoBanner2,
    text: 'Live Casino',
  },
];

const IND_CASINO_MOBILE_BANNERS = [
  {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/indian_casino_mob.png',
    text: 'Indian Casino',
  },
];

export default {
  CASINO_WEB_BANNERS,
  FUN_GAMES_MOB_BANNER,
  FUN_GAMES_WEB_BANNER,
  CASINO_MOBILE_BANNERS,
  IND_CASINO_WEB_BANNERS,
  IND_CASINO_MOBILE_BANNERS,
};
